import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { manualOps, type ManualOperationListItem } from '@/api/documents';
import DataTable, { type ColumnDef } from '@/shared/components/DataTable';

export default function ManualOperationsPage() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const list = useQuery({
    queryKey: ['manual-ops'],
    queryFn: () => manualOps.list({ limit: 200 }),
  });

  const cols = useMemo<ColumnDef<ManualOperationListItem>[]>(() => [
    { key: 'document_number', header: t('mo.number'), width: 150, importBadge: true, sortValue: (r) => r.document_number ?? '', cell: (r) => r.document_number },
    { key: 'document_date', header: t('mo.date'), width: 170, sortValue: (r) => r.document_date ?? '', cell: (r) => r.document_date ? new Date(r.document_date).toLocaleString(i18n.language) : '' },
    { key: 'operation_content', header: t('mo.content'), sortValue: (r) => r.operation_content ?? '', cell: (r) => r.operation_content },
    { key: 'posted', header: t('mo.posted'), width: 130, align: 'center', sortValue: (r) => r.posted ? 1 : 0, cell: (r) => r.posted ? '✓ ' + t('mo.posted_yes') : t('mo.posted_no') },
  ], [t, i18n.language]);

  return (
    <>
      <div className="toolbar">
        <h2 style={{ margin: 0 }}>{t('mo.title')}</h2>
        <button className="primary" onClick={() => navigate('/manual-operations/new')}>
          + {t('mo.new')}
        </button>
      </div>
      <DataTable<ManualOperationListItem>
        rows={list.data?.items ?? []}
        columns={cols}
        rowKey={(r) => r.id}
        loading={list.isLoading}
        emptyText="Немає документів."
        onRowDoubleClick={(r) => navigate(`/manual-operations/${r.id}`)}
        rowMuted={(r) => r.deletion_mark ? 0.4 : undefined}
        initialSortKey="document_date"
        initialSortDir="desc"
      />
    </>
  );
}
